import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    mlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size,
    viewBox: "0 0 24 24",
    class: _normalizeClass(["maz-arrow-icon", [{ 'is-white': _ctx.dark }, _ctx.orientation]])
  }, [
    _createElementVNode("path", {
      fill: _ctx.color,
      class: _normalizeClass([[_ctx.color], "arrow"]),
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    }, null, 10, _hoisted_2),
    _hoisted_3
  ], 10, _hoisted_1))
}